module.exports = __webpack_public_path__ + "static/media/mapPointer.3dc5f5f0.png";